import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import Modal from '@deprecated-ui/common/Modal';
import useTradingAccount from 'hooks/useTradingAccount';
import tradingDataStore from 'lib/stores/tradingData';
import tradingOperationStore from 'lib/stores/tradingOperation';
import { useState } from 'react';
import orderbookModalStore from './store';

interface PreviewModalProps {
  visible: boolean;
}

function Withdraw({ visible }: PreviewModalProps) {
  const { postTradeCancel } = tradingOperationStore();
  const { isRealTrading } = useTradingAccount();
  const { orders, resetModal } = orderbookModalStore();
  const { getOrderHistory } = tradingDataStore();
  const [isLoading, setIsLoading] = useState(false);

  const withdrawOrders = async () => {
    setIsLoading(true);
    try {
      const submissions = orders.map((order, i) => {
        const data = {
          orderkey: `W-WITHDRAW-${Date.now()}`,
          symbol: order.symbol,
          orderid: order.orderid,
          gtc: 0,
          isRealTrading,
        };
        return postTradeCancel(data);
      });

      const results = await Promise.all(submissions);

      setIsLoading(false);
      getOrderHistory(isRealTrading);
      resetModal();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      visible={visible}
      width="520px"
      // @ts-expect-error
      cancelable={!isLoading}
      onCancel={resetModal}
      centered
    >
      {/* @ts-expect-error */}
      <Text family="bold" pt="20px" size="18px" align="center">
        Withdraw
      </Text>
      {/* @ts-expect-error */}
      <Text p="20px">Are you sure want to withdraw this order?</Text>

      <Flex>
        <Button
          onClick={resetModal}
          style={{ width: '50%', borderRadius: 0, padding: 10 }}
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          loading={isLoading}
          style={{ width: '50%', borderRadius: 0, padding: 10 }}
          disabled={isLoading}
          onClick={withdrawOrders}
        >
          Confirm
        </Button>
      </Flex>
    </Modal>
  );
}

export default Withdraw;
